import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import Search from './search';
import Filters from './filters';
import Cards from './cards';
import { apiFetch } from '../../utils/api.js';

export function Catalog() {
  useEffect(() => { document.title = "Каталог строительных услуг и цены | Комплекс строй"; }, []);

  const [cards, setCards] = useState([]);
  const [filteredCards, setFilteredCards] = useState([]);
  const [loading, setLoading] = useState(true); // Вернули состояние загрузки

  const[filters, setFilters] = useState({
    search: '',
    category: 'all',
    minPrice: 0,
    maxPrice: 0
  });

  const fetchCards = async () => {
    try {
      setLoading(true); // Включаем спиннер
      const response = await apiFetch('/api/cards');
      if (response.ok) {
        const data = await response.json(); 
        setCards(data);
        setFilteredCards(data);
      }
    } catch (err) {
      console.error("Ошибка загрузки:", err);
    } finally {
      setLoading(false); // Выключаем спиннер при любом исходе
    }
  };

  useEffect(() => { fetchCards(); },[]);

  useEffect(() => {
    let result = cards.filter(card => {
      const matchSearch = card.title.toLowerCase().includes(filters.search.toLowerCase());
      const matchCategory = filters.category === 'all' || String(card.category_id) === String(filters.category);
      const matchMinPrice = card.price >= (filters.minPrice || 0);
      const matchMaxPrice = filters.maxPrice > 0 ? card.price <= filters.maxPrice : true;
      
      return matchSearch && matchCategory && matchMinPrice && matchMaxPrice;
    });
    setFilteredCards(result);
  }, [filters, cards]);

  return (
    <div style={{ paddingTop: 'calc(var(--nav-height) + 40px)', paddingBottom: '60px', minHeight: '100vh' }}>
      <Container>
        <Row className="gy-4">
          <Col lg={3}>
            <Filters 
              filters={filters} 
              setFilters={setFilters} 
              // Извлекаем только уникальные категории с их id и name для фильтра
              categories={Array.from(new Map(cards.map(c => [c.category?.id, c.category])).values()).filter(Boolean)} 
            />
          </Col>

          <Col lg={9}>
            <div className="bg-white rounded-3 shadow-sm p-4 mb-4">
              <Search 
                value={filters.search} 
                onChange={(val) => setFilters({...filters, search: val})} 
                count={filteredCards.length}
              />
            </div>
            
            {/* Если данные грузятся, показываем спиннер, иначе — карточки */}
            {loading ? (
              <div className="d-flex justify-content-center align-items-center py-5">
                <Spinner animation="border" style={{ color: 'var(--corp-accent)' }} />
              </div>
            ) : (
              <div className="min-vh-100">
                <Cards cards={filteredCards} />
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}
